import {
  AddOfferType,
  AddProfileAddressType,
  AddProfileCompanyType,
  AddProfileType,
  EditProfileType,
  OfferType,
  ProfileType,
  ProfileSettingsType,
  ImageType,
} from "@jobintrans/base-ui.types.api"
import { APIService } from "./APIService"

const getProfile = (id: string) => APIService.get<null, ProfileType>(`/profiles/${id}`)
const registerProfile = (profile: AddProfileType) =>
  APIService.post<null, ProfileType>(`/profiles`, profile)

// UPDATE
const update = (profile: EditProfileType) =>
  APIService.patch<null, ProfileType>(`/profiles/:profileId`, profile)
const updatePassword = (password: string) =>
  APIService.patch<null, null>(`/profiles/:profileId/password?password=${password}`)
const updateCompany = (company: AddProfileCompanyType) =>
  APIService.patch<null, ProfileType>(`/profiles/:profileId/company`, company)
const updateAddress = (address: AddProfileAddressType) =>
  APIService.patch<null, ProfileType>(`/profiles/:profileId/address`, address)
const updateSettings = (settings: ProfileSettingsType) =>
  APIService.patch<null, ProfileType>(`/profiles/:profileId/settings`, settings)
const updateLogo = (file: any) => {
  const formData = new FormData()
  formData.append("file", file)

  return APIService.put<null, ProfileType>(`/profiles/:profileId/logo`, formData)
}
const deleteLogo = () => APIService.delete<null, ProfileType>(`/profiles/:profileId/logo`)

export const ProfileService = {
  getProfile,
  registerProfile,
  update,
  updatePassword,
  updateCompany,
  updateAddress,
  updateSettings,
  updateLogo,
  deleteLogo,
}
